// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqMyQuotesTypeSelectorStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTypeSelector";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

rfqMyQuotesTypeSelectorStyles.quoteTypeRadioButton = {
    mergeCss: true,
    css: css`
        &&&& {
            margin-top: 0;
        }
    `,
};

rfqMyQuotesTypeSelectorStyles.quoteTypeRadioGroup = {
    css: css`
        display: inline-flex;
        padding-bottom: 25px;
        width: 100%;
        flex-direction: row;
        & > div {
            margin-right: 20px;
            display: inline-flex;
        }
        > ${TypographyStyle} {
            margin: 0;
        }
    `,
};
